import React, { forwardRef } from 'react';
import cn from 'classnames';

import ArrowLeft from '@crehana/crehana-icons/lib/NewArrowLeft';
import ArrowRight from '@crehana/crehana-icons/lib/NewArrowRight';
import ArrowLeftEnd from '@crehana/crehana-icons/lib/ArrowLeftEnd';
import ArrowRightEnd from '@crehana/crehana-icons/lib/ArrowRightEnd';

import { PaginationNumberedProps } from '../types';

import IconButton from '../../Buttons/IconButton';

const Alternative = forwardRef<HTMLDivElement, PaginationNumberedProps>(
  (
    {
      currentPage = 1,
      totalPages = 1,
      onPrev,
      onNext,
      onPageChange,
      dark,
      white,
      className,
      ...other
    },
    ref,
  ) => {
    const onFirst = () => {
      if (typeof onPageChange === 'function') {
        onPageChange(1);
      }
    };

    const onLast = () => {
      if (typeof onPageChange === 'function') {
        onPageChange(totalPages);
      }
    };

    const labelClassNames = cn(
      'font-body3 text-nowrap',
      dark ? 'text-base-lighter' : 'text-gray-dark',
    );

    return (
      <div
        ref={ref}
        className={cn(
          'w-full sm:w-auto flex items-center justify-center sm:justify-start',
          className,
        )}
        {...other}
      >
        <IconButton
          className="sm:hidden"
          customIcon={ArrowLeftEnd}
          darkMode={dark}
          white={white}
          disabled={currentPage <= 1}
          onClick={onFirst}
          xs
        />
        <IconButton
          className="ml-8 sm:hidden"
          customIcon={ArrowLeft}
          darkMode={dark}
          white={white}
          disabled={currentPage <= 1}
          onClick={onPrev}
          xs
        />
        <IconButton
          className="hidden sm:inline-flex"
          customIcon={ArrowLeftEnd}
          darkMode={dark}
          white={white}
          disabled={currentPage <= 1}
          onClick={onFirst}
        />
        <IconButton
          className="hidden sm:inline-flex ml-8"
          arrow="left"
          darkMode={dark}
          white={white}
          disabled={currentPage <= 1}
          onClick={onPrev}
        />
        <span className={cn(labelClassNames, 'ml-12 sm:ml-24')}>Página</span>
        <span
          className={`font-subtitle3 mx-8 ${
            dark ? 'text-white' : 'text-base-main'
          }`}
        >
          {currentPage}
        </span>
        <span className={cn(labelClassNames, 'mr-12 sm:mr-24')}>
          {`de ${totalPages}`}
        </span>
        <IconButton
          className="mr-8 sm:hidden"
          customIcon={ArrowRight}
          darkMode={dark}
          white={white}
          disabled={currentPage >= totalPages}
          onClick={onNext}
          xs
        />
        <IconButton
          className="sm:hidden"
          customIcon={ArrowRightEnd}
          darkMode={dark}
          white={white}
          disabled={currentPage >= totalPages}
          onClick={onLast}
          xs
        />
        <IconButton
          className="hidden sm:inline-flex mr-8"
          arrow="right"
          darkMode={dark}
          white={white}
          disabled={currentPage >= totalPages}
          onClick={onNext}
        />
        <IconButton
          className="hidden sm:inline-flex"
          customIcon={ArrowRightEnd}
          darkMode={dark}
          white={white}
          disabled={currentPage >= totalPages}
          onClick={onLast}
        />
      </div>
    );
  },
);

export default Alternative;
